<template>
  <form
    ref="form"
    data-url="/accreditationExecutive/issuanceResolution/612"
    :class="{ 'loading-opacity': preloader }"
    enctype="multipart/form-data"
  >
    <div class="row">
      <div class="col-12">
        <legend class=" col-form-label text-primary pt-0 mb-3">
          <h5>Documentos de las Evaluaciones / Testificaciones</h5>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">Expediente</th>
              <th scope="col">Tipo</th>
              <th scope="col">Código</th>
              <th scope="col" class="text-center" style="width: 10%">
                Documento
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.evaluations" :key="key">
              <td class="align-middle">
                {{ inputs.record }}
              </td>
              <td class="align-middle">
                <p v-if="value.type == 'E'">Evaluación</p>
                <p v-if="value.type == 'T'">Testificación</p>
              </td>
              <td class="align-middle">{{ value.code }}</td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openModal(value)"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <legend class=" col-form-label text-primary pt-0 mb-3">
          <h5>Documentos</h5>
        </legend>
      </div>
      <div class="col-12">
        <table class="table table-sm table-striped">
          <thead>
            <tr>
              <th scope="col">TIPO</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="inputs.request_signed">
              <td class="align-middle">Solicitud de acreditación firmada</td>
              <td class="align-middle">
                {{
                  inputs.request_signed
                    ? `${inputs.request_signed.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.request_signed
                    ? `${inputs.request_signed.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'request_signed')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr v-if="inputs.request_signed">
              <td class="align-middle">
                Anexos de la Solicitud de Acreditación
              </td>
              <td class="align-middle">
                {{
                  inputs.user
                    ? `${inputs.user.first_name} ${inputs.user.last_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{ inputs.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <a
                  class="btn btn-success"
                  :href="`/accreditations/applications/${inputs.id}?tab=Anexos`"
                  target="_blank"
                  ><app-icon name="file" /> {{ $t("view") }}</a
                >
              </td>
            </tr>
            <tr v-if="inputs.receipt_return_report">
              <td class="align-middle">Registro de Ingreso de solicitud de acreditación y acuse recibo</td>
              <td class="align-middle">
                {{
                  inputs.receipt_return_report
                    ? `${inputs.receipt_return_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.receipt_return_report
                    ? `${inputs.receipt_return_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'receipt_return_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>


            <tr v-if="inputs.technical_file_analysis_report">
              <td class="align-middle">
                Informe Técnico de Análisis de Expediente y de Toma de Decisión
              </td>
              <td class="align-middle">
                {{
                  inputs.technical_file_analysis_report
                    ? `${inputs.technical_file_analysis_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.technical_file_analysis_report
                    ? `${inputs.technical_file_analysis_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'technical_file_analysis_report')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>

            <!--
            <tr>
              <td class="align-middle">Anexo de plan de mantenimiento</td>
              <td class="align-middle">
                {{
                  inputs.maintenance_plan
                    ? `${inputs.maintenance_plan.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.maintenance_plan
                    ? `${inputs.maintenance_plan.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'maintenance_plan')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            -->

            <tr v-for="(value, key) in documents" :key="key">
                <template v-if="value.status.code !='605'">
                <td class="align-middle">{{ value.status.name }}</td>
                <td class="align-middle">
                  {{ value.from_user.full_name }}
                </td>
                <td class="align-middle">
                  {{ value.report_date | dateFormat }}
                  <!--{{ docs.area_director_report.created_at | dateFormat }}-->
                </td>
                <td class="align-middle text-center">
                  <button
                    type="submit"
                    class="btn btn-success"
                    @click.prevent="openTabInfo(value.accreditation_id, value.status.code )"
                  >
                    <!-- @click.prevent="openTabInfo(docs, 'area_director_report')" -->
                    <app-icon name="file" />
                    {{ $t("view") }}
                  </button>
                </td>
                </template>
              </tr>

<!--
            <tr>
              <td class="align-middle">
                Evidencia de participación de los miembros de la comisión
              </td>
              <td class="align-middle">
                {{
                  inputs.evidence_member_participation
                    ? `${inputs.evidence_member_participation.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.evidence_member_participation
                    ? `${inputs.evidence_member_participation.created_at}`
                    : "" | dateFormat
                }}
              </td>

              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'evidence_member_participation')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>



          
            <tr>
              <td class="align-middle">Informe Director de Área</td>
              <td class="align-middle">
                {{
                  inputs.area_director_report
                    ? `${inputs.area_director_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.area_director_report
                    ? `${inputs.area_director_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'area_director_report')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr>
              <td class="align-middle">Informe Coordinación General Técnica</td>
              <td class="align-middle">
                {{
                  inputs.general_technical_coordination_report
                    ? `${inputs.general_technical_coordination_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.general_technical_coordination_report
                    ? `${inputs.general_technical_coordination_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'general_technical_coordination_report')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <tr>
              <td class="align-middle">Borrador Informe Jurídico</td>
              <td class="align-middle">
                {{
                  inputs.legal_report
                    ? `${inputs.legal_report.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.legal_report
                    ? `${inputs.legal_report.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'legal_report')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            -->
            <tr>
              <td class="align-middle">Borrador Resolución</td>
              <td class="align-middle">
                {{
                  inputs.draft_resolution
                    ? `${inputs.draft_resolution.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.draft_resolution
                    ? `${inputs.draft_resolution.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'draft_resolution')
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
            <!--
            <tr>
              <td class="align-middle">Informe Jurídico</td>
              <td class="align-middle">
                {{
                  inputs.legal_report_director
                    ? `${inputs.legal_report_director.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.legal_report_director
                    ? `${inputs.legal_report_director.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'legal_report_director')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr> -->
            <tr>
              <td class="align-middle">Resolución</td>
              <td class="align-middle">
                {{
                  inputs.legal_resolution_director
                    ? `${inputs.legal_resolution_director.user.full_name}`
                    : ""
                }}
              </td>
              <td class="align-middle">
                {{
                  inputs.legal_resolution_director
                    ? `${inputs.legal_resolution_director.created_at}`
                    : "" | dateFormat
                }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="openTab(inputs, 'legal_resolution_director')"
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_605 && inputs.additional_605.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Reunión de la Comisión de Acreditación):</b> Documentos
            adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_605 && inputs.additional_605.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_605" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_605', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_608 && inputs.additional_608.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Informe Director de Área):</b> Documentos adicionales para
            subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_608 && inputs.additional_608.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_608" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_608', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_609 && inputs.additional_609.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Informe Coordinación General Técnica):</b> Documentos
            adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_609 && inputs.additional_609.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_609" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_609', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        class="col-12"
        v-if="inputs.additional_610 && inputs.additional_610.length > 0"
      >
        <legend class="col-form-label text-primary pt-0 mb-3">
          <h5>
            <b>(Elaboración de Informe Jurídico para la Acreditación):</b> Documentos
            adicionales para subsanar o complementar el proceso
          </h5>
        </legend>
        <table
          class="table table-sm table-striped"
          v-if="inputs.additional_610 && inputs.additional_610.length > 0"
        >
          <thead>
            <tr>
              <th scope="col">OBSERVACIÓN</th>
              <th scope="col">NOMBRE</th>
              <th scope="col">FECHA</th>
              <th scope="col" class="text-center" style="width: 10%">ACCIÓN</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in inputs.additional_610" :key="key">
              <td class="align-middle">{{ value.filename }}</td>
              <td class="align-middle">
                {{ value.annexed.user.full_name }}
              </td>
              <td class="align-middle">
                {{ value.annexed.created_at | dateFormat }}
              </td>
              <td class="align-middle text-center">
                <button
                  type="submit"
                  class="btn btn-success"
                  @click.prevent="
                    openTab(inputs, 'additional_610', value.annexed.path)
                  "
                >
                  <app-icon name="file" />
                  {{ $t("view") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
            <label class="mb-0">Fecha de firma de resolución: </label>
            <app-input
              type="date"
              class="col-sm-6"
              v-model="inputs.resolution_date"
              placeholder="Ingrese la fecha del documento."
              :required="true"
              
            />  
        </div>
        <div class="form-group">
          <label>Resolución suscrita <b class="text-danger">*</b></label>
          <app-input
            type="file"
            :label="inputs.file_1 ? inputs.file_1.name : $t('upload_your_file')"
            v-model="inputs.file_1"
            v-if="!inputs.subscribed_accreditation_resolution"
          />
          <div class="mt-2">
            <button
              type="submit"
              class="btn btn-success"
              @click.prevent="
                openTab(inputs, 'subscribed_accreditation_resolution')
              "
              v-if="inputs.subscribed_accreditation_resolution"
            >
              <app-icon name="file" />
              {{ $t("view") }}
            </button>

            <button
              type="submit"
              class="btn btn-danger"
              @click.prevent="
                openDeleteModal('subscribed_accreditation_resolution')
              "
              v-if="inputs.subscribed_accreditation_resolution"
            >
              <app-icon name="trash-2" />
              {{ $t("delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mt-3">
        <button
          type="submit"
          class="btn btn-primary mr-2"
          @click.prevent="submit"
        >
          {{ $t("save") }}
        </button>
      </div>
    </div>

    <issuance-resolution-612-annexes-modal
      v-if="isAddEditModalActive"
      selected-url=""
      @close-modal="closeAddEditModal"
    />

    <director-area-modal
      v-if="isAddEditModalActive"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditModal"
    />

    <app-confirmation-modal
      v-if="deleteModal"
      modal-id="delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
      title="Confirmación"
      message="¿Desea eliminar este archivo?"
    />
  </form>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiUrl";

export default {
  mixins: [FormMixin],

  data() {
    return {
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      preloader: false,
      inputs: {},
      documents:"",
      deleteModal: false,
      selected: "",
    };
  },

  filters: {
    dateFormat: function (value) {
      return moment(value).format("YYYY-MM-DD HH:mm");
    },
  },

  created() {
    this.data();
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },

    data() {
      let url = `${actions.EXECUTIVE_DIRECTOR}/issuanceResolution/612/show?accAppId=${this.$store.state.accreditation.id}`;
      this.axiosGet(url).then((response) => {
        this.inputs = response.data;
        if(response.data.resolution_date) {
          let date = new Date(response.data.resolution_date);
          date.setDate(date.getDate() + 1);
          this.inputs.resolution_date = date;
        } else {
          this.inputs.resolution_date = new Date();
        }
      });
      
      let urlInfo = `${actions.TECHNICAL_ANALYSIS_REPORT}/generalTechnicalCoordination/generalTechnicalCoordinationReport/accreditationData/${this.$store.state.accreditation.id}`;
      this.axiosGet(urlInfo).then((resp) => {
        this.documents = resp.data.documents;
      });

    },

    openModal(evaluation) {
      this.$store.state.qualityManagement.evaluation = evaluation;
      this.openAddEditModal();
    },

    openAddEditModal() {
      this.isAddEditModalActive = true;
    },

    closeAddEditModal() {
      $("#director-area-modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.reSetData();
    },

    submit() {
      let d;
      if (this.inputs.resolution_date != null) {
        d = this.inputs.resolution_date;
        this.inputs.resolution_date = [
          d.getFullYear(),
          d.getMonth() + 1,
          d.getDate(),
        ].join("-");
      }
      let formData = new FormData();
      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },

    afterSuccess({ data: { data } }) {
      this.inputs = data;
      if(data.resolution_date) {
          let date = new Date(data.resolution_date);
          date.setDate(date.getDate() + 1);
          this.inputs.resolution_date = date;
        } 
      this.$toastr.s(this.$t("updated_success"));
    },

    afterFinalResponse() {
      this.preloader = false;
    },

    afterError(res) {
      this.$toastr.e(res.data.message);
    },

    openDeleteModal(fileName) {
      this.selected = fileName;
      this.deleteModal = true;
    },

    confirmed() {
      this.inputs[this.selected] = null;
    },

    cancelled() {
      this.deleteModal = false;
    },

    openTab(obj, fileName, key) {
      if (key) {
        const w = window.open(key, "_blank");
        w.focus();
      } else {
        const w = window.open(obj[fileName].path, "_blank");
        w.focus();
      }
    },
    
    openTabInfo(accAppId = this.$store.state.accreditation.id , status) {
      if (status == "605") {
        let path = `/evaluator/decision/closureFindingsDecision/view/${this.$store.state.accreditation.id}?tab=Borrador del Informe Técnico`;
        window.open(path, "_blank").focus();
      }
      if (status == "608") {
        let path = `/accreditationReview/decision/areaDirectorReport/view/${this.$store.state.accreditation.id}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      if (status == "609") {
        let path = `/accreditationtechnical/generalTechnicalCoordination/generalTechnicalCoordinationReport/view/${this.$store.state.accreditation.id}?tab=Evaluación%20/%20Testificación`;
        window.open(path, "_blank").focus();
      }
      if (status == "610") {
        let path = `/accreditationExecutive/legalValidation/610/view/${this.$store.state.accreditation.id}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
      if (status == "613") {
        let path = `/accreditationExecutive/directorLegalValidation/613/view/${this.$store.state.accreditation.id}?tab=Anexos`;
        window.open(path, "_blank").focus();
      }
    }
  },
};
</script>